import { usePopoverDialog, UsePopoverDialogResponse, UsePopoverDialogProps } from '@frontend/design-system';
import ShareOrgAssetPopoverDialog from './share-org-asset.component';

interface UseShareOrgAssetProps {
  popoverDialogConfig?: UsePopoverDialogProps;
}

interface UseShareOrgAssetResults {
  ShareOrgAssetPopoverDialog: typeof ShareOrgAssetPopoverDialog;
  shareOrgAssestPopoverDialogControls: UsePopoverDialogResponse<HTMLButtonElement, false, HTMLDialogElement>;
}

export const useShareOrgAsset = ({ popoverDialogConfig = {} }: UseShareOrgAssetProps = {}): UseShareOrgAssetResults => {
  const shareOrgAssestPopoverDialogControls = usePopoverDialog(popoverDialogConfig);

  return {
    ShareOrgAssetPopoverDialog,
    shareOrgAssestPopoverDialogControls,
  };
};
